module.exports = __webpack_public_path__ + "img/icon6.3a8163b7.png";